import lazyWithRetry from 'helpers/lazyWithRetry';

const LoginPage = lazyWithRetry(() => import('../pages/auth/LoginPage'));
const ChangePasswordPage = lazyWithRetry(() => import('../pages/auth/ChangePasswordPage'));
const DashboardPage = lazyWithRetry(() => import('../pages/dashboard/DashboardPage'));
const BrandingPage = lazyWithRetry(() => import('../pages/branding/BrandingPage'));
const MarkupRulesPage = lazyWithRetry(() => import('../pages/commercials/MarkupRulesPage'));
const ServiceFeesPage = lazyWithRetry(() => import('../pages/commercials/ServiceFeesPage'));
const PromosPage = lazyWithRetry(() => import('../pages/commercials/PromosPage'));
const PromoCodesPage = lazyWithRetry(() => import('../pages/commercials/PromoCodesPage'));
const UsersRolesPage = lazyWithRetry(() => import('../pages/platform/UsersRolesPage'));
const WalletPage = lazyWithRetry(() => import('../pages/platform/WalletPage'));
const BookingListPage = lazyWithRetry(() => import('../pages/bookings/BookingListPage'));
const BookingDetailPage = lazyWithRetry(() => import('../pages/bookings/BookingDetailPage'));
const CustomerListPage = lazyWithRetry(() => import('../pages/customers/CustomerListPage'));
const CustomerDetailPage = lazyWithRetry(() => import('../pages/customers/CustomerDetailPage'));
const ManualHotelBookingPage = lazyWithRetry(() => import('../pages/bookings/ManualHotelBookingPage'));
const ManualFlightBookingPage = lazyWithRetry(() => import('../pages/bookings/ManualFlightBookingPage'));
const ServicingQueuePage = lazyWithRetry(() => import('../pages/servicing/ServicingQueuePage'));
const TransactionsPage = lazyWithRetry(() => import('../pages/finance/TransactionsPage'));
const GstPage = lazyWithRetry(() => import('../pages/gst/GstPage'));
const CommHubPage = lazyWithRetry(() => import('../pages/communications/CommHubPage'));
const SalesReportPage = lazyWithRetry(() => import('../pages/reports/SalesReportPage'));
const AgentReportPage = lazyWithRetry(() => import('../pages/reports/AgentReportPage'));
const SupplierReportPage = lazyWithRetry(() => import('../pages/reports/SupplierReportPage'));
const TransactionReportPage = lazyWithRetry(() => import('../pages/reports/TransactionReportPage'));
const TravelPage = lazyWithRetry(() => import('../pages/travel/TravelPage'));
const ProfilePage = lazyWithRetry(() => import('../pages/profile/ProfilePage'));

export const routes = [
  { path: '/', element: <DashboardPage /> },
  // Embedded traveller-app surfaces. One component, three routes — `surface`
  // is the only thing that differs.
  { path: '/travel/chat', element: <TravelPage surface="chat" /> },
  { path: '/travel/shop', element: <TravelPage surface="shop" /> },
  { path: '/travel/history', element: <TravelPage surface="history" /> },
  { path: '/travel/emails', element: <TravelPage surface="emails" /> },
  { path: '/branding', element: <BrandingPage /> },
  { path: '/commercials/markup', element: <MarkupRulesPage /> },
  { path: '/commercials/fees', element: <ServiceFeesPage /> },
  { path: '/commercials/promos', element: <PromosPage /> },
  { path: '/commercials/promo-codes', element: <PromoCodesPage /> },
  { path: '/platform/users', element: <UsersRolesPage /> },
  { path: '/platform/wallet', element: <WalletPage /> },
  { path: '/bookings', element: <BookingListPage /> },
  { path: '/bookings/manual-hotel', element: <ManualHotelBookingPage /> },
  { path: '/bookings/manual-flight', element: <ManualFlightBookingPage /> },
  { path: '/bookings/:id', element: <BookingDetailPage /> },
  { path: '/customers', element: <CustomerListPage /> },
  { path: '/customers/:id', element: <CustomerDetailPage /> },
  { path: '/servicing', element: <ServicingQueuePage /> },
  { path: '/finance/transactions', element: <TransactionsPage /> },
  { path: '/gst', element: <GstPage /> },
  { path: '/communications', element: <CommHubPage /> },
  { path: '/reports/sales', element: <SalesReportPage /> },
  { path: '/reports/agents', element: <AgentReportPage /> },
  { path: '/reports/suppliers', element: <SupplierReportPage /> },
  { path: '/reports/transactions', element: <TransactionReportPage /> },
  { path: '/profile', element: <ProfilePage /> },
];

/**
 * Both sit OUTSIDE `routes` on purpose: those render inside AppLayout, and
 * neither a login nor a forced password rotation should show the console shell —
 * the sidebar would invite navigation away from a step the user must complete.
 */
export { LoginPage, ChangePasswordPage };
